import { useEffect, useState } from 'react';
import Paper from '@mui/material/Paper';
import { Grid, Card, CardContent, Button, IconButton, MenuItem, Select, Typography } from '@mui/material';
import { gridSpacing } from '../../constant/Constants';
import { useMediaQuery, useTheme } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { makeStyles } from '@mui/styles';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import OTPInput from "otp-input-react";
import {
    validatePin4Length,
} from '../../utils/regex/Regex';
import { showAlert } from '../../redux/create-actions/AlertAction';
import { useDispatch, useSelector } from 'react-redux';
import { showOtpModalSetPin } from '../../redux/create-actions/OtpAction';
import { closeLoadingApi, openLoadingApi } from '../../redux/create-actions/LoadingAction';
import FontSize from '../../layouts/FontSize';
import Color from '../../layouts/Color';
import { graphGenOtp } from '../../services/OneTimePassword';
import { graphGetAllContractByCustomer } from '../../services/Contract';

const useStyles = makeStyles(function (theme) {
    return {
        gridContainer: {
            [theme.breakpoints.up("sm")]: {
                paddingLeft: '100px',
                paddingRight: '100px'
            },
            [theme.breakpoints.up("md")]: {
                paddingLeft: '150px',
                paddingRight: '150px'
            },
            [theme.breakpoints.up("lg")]: {
                paddingLeft: '200px',
                paddingRight: '200px'
            },
            [theme.breakpoints.only("xl")]: {
                paddingLeft: '20vw',
                paddingRight: '20vw'
            },
        },
    };
});

const paperStyle = { my: { xs: 1, md: 2 }, p: { xs: 1, md: 3 }, minHeight: '100%' };
const container = { mt: 1, textAlign: 'left' };
const buttonSubmit = {
    color: Color.Button,
    backgroundColor: Color.Dangerous,
    '&:hover': { background: Color.Button, color: Color.Dangerous }
};

export default function PinSetForm(props) {
    const classes = useStyles();
    const theme = useTheme();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));

    const [contract, setContract] = useState(null);
    const [contractID, setContractID] = useState(null)
    const [listContract, setListContract] = useState([]);
    const [showPin, setShowPin] = useState(false);
    const [showPinConfirm, setShowPinConfirm] = useState(false);
    const handleClickShowPin = () => setShowPin(!showPin);
    const handleMouseDownPin = () => setShowPin(!showPin);
    const handleClickShowPinConfirm = () => setShowPinConfirm(!showPinConfirm);
    const handleMouseDownPinConfirm = () => setShowPinConfirm(!showPinConfirm);
    const [pin, setPin] = useState("");
    const [pinLength, setPinLength] = useState(4);
    const [pinConfirm, setPinConfirm] = useState("");
    const data = useSelector(state => state.otp.data)

    const dispatch = useDispatch();

    useEffect(() => {
        if (contract !== null) {
            setPinLength(contract.product.pinLength)
            if (data.newPin === '') {
                setPin("");
                setPinConfirm("");
            }
        }
    }, [contract, data.newPin]);

    useEffect(() => {
        if (contractID !== null && listContract.length !== 0) {
            setContract(listContract.filter((e) => e.id === contractID)[0]);
        }
    }, [contractID, listContract])

    useEffect(() => {
        dispatch(openLoadingApi());
        const promise = graphGetAllContractByCustomer();
        promise.then((result) => {
            setContractID(result.items[0].id);
            setListContract(result.items);
            dispatch(closeLoadingApi());
        }).catch(error => {
            const err = JSON.parse(JSON.stringify(error))
            console.log(err);
            dispatch(closeLoadingApi());
        })
    }, [dispatch])

    const handleChangePin = (event) => {
        var value = pin ? event : (pin + event);
        setPin(value);
    };

    const handleChangePinConfirm = (event) => {
        var value = pinConfirm ? event : (pinConfirm + event);
        setPinConfirm(value);
    };

    const handleClick = () => {
        let validate = validatePin4Length(pin);
        let alert = {
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'center'
            },
            isOpen: true,
            severity: 'error',
            title: 'Error',
            message: '',
        };
        if (pin === pinConfirm) {
            if (!validate) {
                alert = { ...alert, message: "Please select correct PIN format!" };
                dispatch(showAlert(alert));
            }
            else {
                dispatch(openLoadingApi());

                let sendOtp = graphGenOtp();
                sendOtp
                    .then(result => {
                        if (result === 'SMS') {
                            alert = { ...alert, severity: 'info', title: 'Information', message: "Please enter the OTP code sent to your phone number" };
                            dispatch(closeLoadingApi());
                            dispatch(showAlert(alert));
                            dispatch(showOtpModalSetPin(contractID, pin, "SET_PIN"));
                        } else {
                            alert = { ...alert, severity: 'info', title: 'Information', message: "Please enter the OTP code in your Google Authenticator App" };
                            dispatch(closeLoadingApi());
                            dispatch(showAlert(alert));
                            dispatch(showOtpModalSetPin(contractID, pin, "SET_PIN"));
                        }
                    }).catch(function (error) {
                        const err = JSON.parse(JSON.stringify(error))
                        alert = { ...alert, message: err.response.errors[0].message };
                        dispatch(closeLoadingApi());
                        dispatch(showAlert(alert));
                    })
            }
        }
        else {
            alert = { ...alert, message: "New PIN and Confirm PIN are not the same!" }
            dispatch(showAlert(alert));
        }
    }

    const renderReloadPin = (OTPLength) => {
        return (
            <Grid item md={9} xs={12} sx={{ display: 'flex', alignItem: 'center', justifyContent: `${matchDownSM ? 'center' : 'start'}` }}>
                <OTPInput
                    value={pin}
                    onChange={handleChangePin}
                    autoFocus
                    OTPLength={OTPLength}
                    inputStyles={{
                        marginRight: `${matchDownSM ? '5px' : '20px'}`,
                        outline: 'none',
                        border: '1px solid ' + Color.Button,
                        borderBottom: '1px solid ' + Color.Main,
                        width: `${matchDownSM ? '28px' : '32px'}`,
                        height: `${matchDownSM ? '28px' : '32px'}`,
                        display: 'flex',
                    }}
                    secure={showPin ? false : true}
                    otpType="number"
                    disabled={false}
                    style={{ marginLeft: ` ${matchDownSM ? '5px' : '20px'}` }}
                />
                <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPin}
                    onMouseDown={handleMouseDownPin}
                >
                    {showPin ? <Visibility /> : <VisibilityOff />}
                </IconButton>
            </Grid>
        )
    }

    const renderReloadPinConfirm = (OTPLength) => {
        return (
            <Grid item md={9} xs={12} sx={{ display: 'flex', alignItems: 'center', justifyContent: `${matchDownSM ? 'center' : 'start'}` }}>
                <OTPInput
                    sm={9} xs={9} md={9} xl={9}
                    value={pinConfirm}
                    onChange={handleChangePinConfirm}
                    autoFocus
                    OTPLength={OTPLength}
                    inputStyles={{
                        marginRight: `${matchDownSM ? '5px' : '20px'}`,
                        outline: 'none',
                        border: '1px solid #fff',
                        borderBottom: '1px solid #999',
                        width: `${matchDownSM ? '28px' : '32px'}`,
                        height: `${matchDownSM ? '28px' : '32px'}`,
                        display: 'flex'
                    }}
                    secure={showPinConfirm ? false : true}
                    otpType="number"
                    disabled={false}
                    style={{
                        marginLeft: ` ${matchDownSM ? '5px' : '20px'}`,
                    }}
                />
                <IconButton sm={3} xs={3} md={3} xl={3}
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPinConfirm}
                    onMouseDown={handleMouseDownPinConfirm}
                    size={matchDownSM ? "small" : "medium"}
                >
                    {showPinConfirm ? <Visibility /> : <VisibilityOff />}
                </IconButton>
            </Grid>
        )
    }

    const handleChangeContract = (event) => {
        setContractID(event.target.value);
    };

    return (contract !== null && contractID !== null) ? (
        <Paper variant="outlined" sx={paperStyle} >
            <Grid container alignContent="center" justifyContent="space-between">
                <Grid item>
                    <Button id="set-pin" endIcon={<SettingsIcon />} sx={{ color: theme.typography.h3, cursor: 'default', fontSize: FontSize.Normal }}>
                        Set PIN
                    </Button>
                </Grid>
            </Grid>
            <Card>
                <CardContent>
                    <Grid container spacing={gridSpacing} className={classes.gridContainer} alignItems="center" justifyContent="center" sx={container}>
                        {matchDownSM ? (
                            <></>
                        ) : (
                            <Grid item md={3} xs={12}>
                                <Typography variant="h4"> Card Number: </Typography>
                            </Grid>
                        )}
                        <Grid item md={9} xs={12}>
                            <Select
                                fullWidth
                                labelId="cardnumberl-filter"
                                id="demo-simple-select-helper"
                                value={contractID}
                                onChange={handleChangeContract}
                                size="medium"
                                sx={{
                                    '& .MuiInputBase-input': {
                                        bgcolor: theme.palette.background.default
                                    },
                                    bgcolor: theme.palette.background.default,
                                }}
                            >
                                {
                                    listContract?.map((contract) => {
                                        return (
                                            <MenuItem key={contract.id} id={contract.id} value={contract.id}>
                                                {(contract.contractNumber).slice(0, 4)}&emsp;{(contract.contractNumber).slice(4, 8).replace("__", "**")}&emsp;{(contract.contractNumber).slice(8, 12).replace("____", "****")}&emsp;{(contract.contractNumber).slice(12, 16)}
                                            </MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </Grid>
                        <Grid item md={3} xs={12}>
                            <Typography variant="h4"> New PIN: </Typography>
                        </Grid>
                        {renderReloadPin(pinLength)}
                        <Grid item md={3} xs={12}>
                            <Typography variant="h4"> Confirm PIN: </Typography>
                        </Grid>
                        {renderReloadPinConfirm(pinLength)}
                        {matchDownSM ? (
                            <></>
                        ) : (
                            <Grid item sm={0} xs={0} md={3} xl={3}></Grid>
                        )}
                        <Grid item sm={12} xs={12} md={9} xl={9} sx={{ textAlign: `${matchDownSM ? 'center' : 'left'}`, }}>
                            <Button
                                sx={buttonSubmit}
                                variant="contained"
                                onClick={handleClick}
                                endIcon={<KeyboardArrowUpIcon></KeyboardArrowUpIcon>}
                            >
                                Submit</Button>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        </Paper>
    ) : (
        <Paper variant="outlined" sx={paperStyle} >

        </Paper>
    );
}